module.exports = require("@pnotify/font-awesome4");